import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS } from '@core/const';
import { OccMenuItem, OccMenuParams } from '@main/categories-menu/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccMenuService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  load({ nodeId, level }: OccMenuParams): Observable<OccMenuItem> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.menu, { queryParams: { nodeId, level } });

    return this.http.get<OccMenuItem>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.menu),
    });
  }
}
